import { Controller } from "@hotwired/stimulus"

// Manages cascading enable/disable for agentic kill switch checkboxes.
// Hierarchy: start → create → send
// - Enabling "create" also enables "start"
// - Enabling "send" also enables "create" and "start"
// - Disabling "start" also disables "create" and "send"
// - Disabling "create" also disables "send"
export default class extends Controller {
  static targets = ["start", "create", "send"]

  startChanged() {
    if (!this.startTarget.checked) {
      this.createTarget.checked = false
      this.sendTarget.checked = false
    }
  }

  createChanged() {
    if (this.createTarget.checked) {
      this.startTarget.checked = true
    } else {
      this.sendTarget.checked = false
    }
  }

  sendChanged() {
    if (this.sendTarget.checked) {
      this.startTarget.checked = true
      this.createTarget.checked = true
    }
  }
}
